import React from 'react';
import { useLocation } from 'react-router';
import { get } from 'lodash-es';

import getSessionTitle from './diy-utils/getSessionTitle';

const DiyTitleBar = ({ bin, step }) => {
  const { state } = useLocation();
  const isEditingBin = bin && 'step5';
  const isEditingLiveTimed = !bin && 'step6';
  const isEditingSession = get(state, 'linkedFrom', null) === isEditingBin || isEditingLiveTimed;

  if (step === 6 || step === 7) {
    return null;
  }

  return (
    <h1 className="pt-4" style={{ fontSize: '1.4286rem' }}>
      Step {step}: {getSessionTitle({ step, bin, isEditingSession })}
    </h1>
  );
};

export default DiyTitleBar;
